import ReduxStoreInterface from "model/ReduxStoreInterface";

export const secondaryMarketPredictPriceSelector = (state: ReduxStoreInterface) => state.secondaryMarket.data.predictPriceData;